export var matchesResolution = function (width1, height1, width2, height2) {
    return (width1 === width2 && height1 === height2) ||
        (width1 === height2 && height1 === width2); // Rotated
};
